<div class="lp-if-canvas-component" style="width: 100%; height: 100%">
  <lp-canvas-components [components]="components()" [context]="context()" />
</div>
